import InputBox from "../../../../Component/DigitalMarketing/Forms/InputBox";

export const headCells = [
  {
    id: "created",
    numeric: false,
    disablePadding: true,
    label: "Created",
  },
  {
    id: "name",
    numeric: true,
    disablePadding: false,
    label: "Name",
  },
  {
    id: "phone_number",
    numeric: true,
    disablePadding: false,
    label: "Phone number",
  },
  {
    id: "branch_name",
    numeric: true,
    disablePadding: false,
    label: "Branch Name",
  },
  {
    id: "wellness",
    numeric: true,
    disablePadding: false,
    label: "Wellness Category",
  },
  {
    id: "service",
    numeric: true,
    disablePadding: false,
    label: "Service chosen",
  }, 
  {
    id: "ivf_status",
    numeric: true,
    disablePadding: false,
    label: "Treatment Journey",
  },
  {
    id: "source",
    numeric: true,
    disablePadding: false,
    label: "Source",
  },
  {
    id: "status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  // {
  //   id: "last_contacted",
  //   numeric: true,
  //   disablePadding: false,
  //   label: "Last Contacted",
  // },
  {
    id: "action",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
];
export const LeadBulkuploadForm = [
  {
    tag: InputBox,
    label: "Upload Leads",
    type: "file",
    key_name: "file",
  },
];
